import { setupCrossSell } from "./cross-sell";

export function setupCultureCircleBrandSpecificScripts() {
  if (!window.location.host.includes("culture-circle.com")) return;

  if (
    window.location.pathname === "/checkout" ||
    window.location.pathname.includes("order")
  )
    setupCrossSell();
}
